import { useTranslation } from "react-i18next";
import { QRCode } from "./QRCode";

export const EntryScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-10 bg-very-black ">
      <div className="bg-inverted w-[600px] flex flex-col items-center p-10 rounded-[20px]">
        <img src="/svg/very.svg" />

        <div className="text-size-40 text-default mt-[60px]">
          Verify with VeryAI
        </div>
        <div className="text-size-20 text-default mt-2 mb-4">
          Scan the QR code with your camera <br /> to launch the VeryAI app
        </div>

        <div className="p-5">
          <QRCode url={location.href} />
        </div>
      </div>
      <div className="text-size-16 font-semibold">{t("qrCode.scanQRCode")}</div>
    </div>
  );
};
